<template>
    <!-- 一般vue项目都会使用vue-router -->
    <!-- 所以我们这里直接写一个 router-view -->

    <el-config-provider :locale="locale === 'en-US' ? enUS : zhCN">
        <router-view></router-view>
    </el-config-provider>
</template>
<script setup>
import zhCN from 'element-plus/es/locale/lang/zh-cn';
import enUS from 'element-plus/es/locale/lang/en'
import { useI18n } from 'vue-i18n';

const { locale } = useI18n()
// 禁止web端屏幕缩放
window.addEventListener(
    'mousewheel',
    function (event) {
        if (event.ctrlKey === true || event.metaKey) {
            event.preventDefault();
        }
    },
    { passive: false }
);
</script>
<!-- @media only screen and (min-width:1920px) {
@media only screen and (min-width:1440px) and (max-width: 1919px) {
@media only screen and (min-width: 1024px) and (max-width: 1439px) {
@media only screen and (min-width: 769px) and (max-width: 1023px) {
@media only screen and (max-width:768px) { -->